<p *ngFor="let host of hosts">{{ host }}</p>